// Source: app/scripts/controllers/movement-certificate-display-controller.js
Auction.controller('MovementCertificateDisplayController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages) {
          var urlNumber = $location.search().urlNumber;

          var movementCertificateService = crudService("movement_certificates", {
            'displayMovementCertificates': {
            method: 'GET',
            isArray: false,
            url: '/data/rest/movement_certificates/movement_certificate_display/:urlNumber'}});

          var vm = {};

          movementCertificateService.displayMovementCertificates({urlNumber: urlNumber}, function (data) {

              $scope.vm = data;
           });


}
]);

